class Settings {
    constructor(user) {
      this.container = document.getElementById('settings');
      this.subscriptions = [];
      this.subscriptionListElement = this.container.querySelector('#subscription-list');
      this.themeToggle = this.container.querySelector('.switch');
      this.languageSelect = this.container.querySelector('.language-select');
      this.closeButton = this.container.querySelector('.icon-arrow-left');
      this.initializeEventListeners();

      // Set initial values
      if(localStorage.getItem('theme') === 'dark') this.themeToggle.click();

    }
  
    initializeEventListeners() {
      // Toggle theme
      this.themeToggle.addEventListener('change', (event) => {
        this.toggleTheme(event.target.checked);
      });
  
      // Change language
      this.languageSelect.addEventListener('change', (event) => {
        this.changeLanguage(event.target.value);
      });

      // Close settings
      this.closeButton.addEventListener('click', () => {
        this.close();
      });

      this.hadnleKeydown = this.hadnleKeydown.bind(this);
  
    }
  
    toggleTheme(isLightMode) {
      if (isLightMode) {
        document.documentElement.setAttribute('data-theme', 'dark');
        localStorage.setItem('theme', 'dark');
      } else {
        document.documentElement.setAttribute('data-theme', 'light');
        localStorage.setItem('theme', 'light');
      }
    }
  
    changeLanguage(languageCode) {
      console.log(`Language changed to: ${languageCode}`);
      // Handle language change, such as fetching new language data and updating the UI
    }
  
    addSubscription(device, daysUntilBilling) {
        if (device !== undefined) {
            const subscription = { device, daysUntilBilling };
            subscription.device.data.forEach((item)=> {
                this.subscriptions.push(item);
            })

            this.renderSubscriptions();
        } else {
            return;
        }
    }

    show(data, userData){
        this.addSubscription(data);
        this.container.classList.add('show');
        this.container.classList.add('fadeInUp');
        document.querySelector(".setting-item__email").innerHTML = userData.data.email;
        setTimeout(() => {
            this.container.classList.remove('fadeInUp')
        },500)
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', this.hadnleKeydown);
    }

    hadnleKeydown(event){
        if(event.key == 'Escape'){
            this.close();
        }
    }

    close(){
        this.subscriptions = [];
        this.subscriptionListElement.innerHTML = '';
        this.container.classList.add('fadeOutDown');
        setTimeout(() => {
            this.container.classList.remove('show');
            this.container.classList.remove('fadeOutDown');
            this.container.classList.add('fadeInUp');
            document.body.style.overflow = '';
        },500)

      
        document.removeEventListener('keydown', this.hadnleKeydown);
        
    }
  
    renderSubscriptions() {
      document.querySelector(".setting-item__text").style.display =  'none';
      document.querySelector(".setting-item--sub").style.flexDirection =  'column';
      this.subscriptionListElement.innerHTML = ''; // Clear current list
      this.subscriptions.forEach((subscription) => {

        const row = document.createElement('div');
        row.className = 'subscription-table-row';
        const deviceCell = document.createElement('div');
        deviceCell.className = 'row__item';
        deviceCell.textContent = subscription.device_name;
        const daysCell = document.createElement('div');
        daysCell.className = 'row__item';
        if (subscription.subState === 'expired' || subscription.subState === 'refunded' || subscription.subState === 'invalid' || subscription.subState === '') {
            daysCell.textContent = 'No Active Subscription';
        } else {
            daysCell.textContent = 'Subscription Active';
        }
        row.appendChild(deviceCell);
        row.appendChild(daysCell);
        this.subscriptionListElement.appendChild(row);
      });
    }
}

module.exports = Settings;
  
  